import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "../../lib/ContentContext";

export default function CTA() {
  const { getText } = useContent();
  return (
    <section className="relative py-28 md:py-44 overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full bg-[#0057ff] opacity-15 blur-[180px]" />
      </div>

      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="font-display text-white text-5xl md:text-7xl leading-[1.02] tracking-tight max-w-5xl"
        >
          {getText("cta.title_a")} <br />
          <span className="italic-accent text-grad-crimson">{getText("cta.title_b")}</span>
        </motion.h2>

        <div className="mt-14 flex flex-wrap items-center gap-4">
          <Link to={getText("cta.primary_url")} className="btn btn-primary" data-testid="cta-primary">
            {getText("cta.primary_label")}
            <ArrowUpRight className="w-5 h-5" />
          </Link>
          <Link to={getText("cta.secondary_url")} className="btn btn-glass" data-testid="cta-secondary">
            {getText("cta.secondary_label")}
          </Link>
        </div>
      </div>
    </section>
  );
}
